import { ChangeDetectionStrategy, Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Layout } from '@modules/core/utils';

@Component({
  selector: 'pub-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RootComponent extends Layout implements OnInit {
  @ViewChild('containerRef', { read: ViewContainerRef, static: true }) containerRef!: ViewContainerRef;
  title = 'public-page';
  constructor() {
    super();
  }

  ngOnInit(): void {
    this.injectLayout('RootLayoutComponent', 'layouts/root-layout/');
  }
}
